/**
 * `Object.keys` with a type-safe return value.
 *
 * Note that due to structural typing, the object may have more keys at runtime than exist on the
 * type at compile time.
 */
export const unsafeObjectKeys = <Key extends string>(object: Record<Key, unknown>) =>
  Object.keys(object) as Key[];

/**
 * `Object.fromEntries` with a type-safe return value.
 *
 * Note that due to structural typing, the object may have more entries at runtime than exist on the
 * type at compile time.
 */
export const unsafeObjectFromEntries = <Key extends string, Value>(pairs: Array<[Key, Value]>) =>
  Object.fromEntries(pairs) as Record<Key, Value>;

/**
 * `Object.entries` with a type-safe return value.
 *
 * Note that due to structural typing, the object may have more entries at runtime than exist on the
 * type at compile time.
 */
export const unsafeObjectEntries = <Key extends string, Value>(object: Record<Key, Value>) =>
  Object.entries(object) as Array<[Key, Value]>;
